import { gql } from '__generated__';

export default gql(`
  mutation EditMailOptIns($input: EditMailOptInsInput!) {
    editMailOptIns(input: $input) {
      id
      available_mail_permissions {
        id
        title
      }
      granted_mail_permissions {
        id
      }
    }
  }
`);
